import { defineStore } from 'pinia'
import House from '@/assets/icons/House.svg'
import DocumentIcon from '@/assets/icons/File_Document.svg'
import BuildingIcon from '@/assets/icons/Building_04.svg'
import FileCheckIcon from '@/assets/icons/File_Check.svg'
import LayersIcon from '@/assets/icons/Layers.svg'
import FoldersIcon from '@/assets/icons/Folders.svg'
import CalendarIcon from '@/assets/icons/Calendar.svg'
import CalendarCheckIcon from '@/assets/icons/Calendar_Check.svg'
import ArchiveIcon from '@/assets/icons/Archive.svg'
import HeartIcon from '@/assets/icons/Heart_01.svg'
import StarIcon from '@/assets/icons/Star.svg'
import Building3Icon from '@/assets/icons/Building_03.svg'
import UserIcon from '@/assets/icons/Users_Group.svg'
import Stars from '@/assets/icons/Stars_2.svg'
import FileBlankIcon from '@/assets/icons/File_Blank.svg'
import ChatIcon from '@/assets/icons/Chat_Conversation_Circle.svg'

import { useUserStore } from '@/store/UserStore'
import { getMaxRole, checkRole, findRole } from '@/utils/role'

export const useNavigationStore = defineStore('navigation', {
    state: () => ({
        activeTabId: localStorage.getItem('active_tab') || 'home',
        tabs: [
            {
                id: 'ai',
                text: 'Асистент',
                path: '/agent',
                icon: Stars,
                active: true,
                minRole: 'ROLE_DIRECTOR',
                excludeRole: 'ROLE_ADMIN',
                llmEnabled: true,
            },
            {
                id: 'chat',
                text: 'Чаты',
                path: '/chat',
                icon: ChatIcon,
                active: false,
                minRole: 'ROLE_WORKER',
                excludeRole: 'ROLE_ADMIN',
            },
            {
                id: 'home',
                text: 'Обзор',
                path: '/home',
                icon: House,
                active: true,
                minRole: 'ROLE_DIRECTOR',
                excludeRole: 'ROLE_ADMIN',
            },
            {
                id: 'activity',
                text: 'Обзор активности',
                path: '/activity',
                icon: CalendarCheckIcon,
                minRole: 'ROLE_FOREMAN',
                active: false,
                excludeRole: 'ROLE_ADMIN',
            },
            {
                id: 'warehouse',
                text: 'Склады',
                path: '/warehouse',
                icon: Building3Icon,
                minRole: 'ROLE_DIRECTOR',
                active: false,
                excludeRole: 'ROLE_ADMIN',
            },
            {
                id: 'company',
                text: 'Компании',
                path: '/company',
                icon: BuildingIcon,
                active: false,
                minRole: 'ROLE_DIRECTOR',
                excludeRole: 'ROLE_ADMIN',
            },
            {
                id: 'files',
                text: 'Строй диск',
                path: '/files',
                icon: FileBlankIcon,
                active: false,
                hasRole: 'ROLE_DIRECTOR',
                excludeRole: 'ROLE_ADMIN',
            },
            {
                id: 'project',
                text: 'Проекты',
                path: '/project',
                icon: FoldersIcon,
                active: false,
                excludeRoles: ['ROLE_ADMIN', 'ROLE_DIRECTOR', "ROLE_OWNER", "ROLE_WORKER"],
            },
            {
                id: 'stages',
                text: 'Этапы',
                path: '/stage',
                icon: LayersIcon,
                active: false,
                hasRoles: ['ROLE_FOREMAN'],
                excludeRoles: ['ROLE_ADMIN', 'ROLE_DIRECTOR', "ROLE_OWNER"],
            },
            {
                id: 'works',
                text: 'Работы',
                path: '/work',
                icon: CalendarIcon,
                minRole: 'ROLE_WORKER',
                maxRole: 'ROLE_FOREMAN',
                active: false,
                excludeRole: 'ROLE_ADMIN',
            },
            {
                id: 'task',
                text: 'Задачи',
                path: '/task',
                icon: FileCheckIcon,
                active: false,
                excludeRoles: ['ROLE_ADMIN', 'ROLE_DIRECTOR', "ROLE_OWNER"],
            },
            {
                id: 'smeta',
                text: 'Сметы',
                path: '/smeta',
                icon: DocumentIcon,
                active: false,
                minRole: 'ROLE_DIRECTOR',
                excludeRole: 'ROLE_ADMIN',
            },
            {
                id: 'wishesProcessing',
                text: 'Обработка пожеланий',
                path: '/wishes/support',
                icon: HeartIcon,
                active: false,
                hasRole: 'ROLE_SUPPORT',
            },
            {
                id: 'changelog',
                text: 'Изменения',
                path: '/changelog',
                icon: ArchiveIcon,
                active: false,
                bottom: true
            },
            {
                id: 'wishes',
                text: 'Пожелания',
                path: '/wishes',
                icon: HeartIcon,
                active: false,
                bottom: true,
                excludeRole: 'ROLE_ADMIN',
            },
            {
                id: 'specializations',
                text: 'Специализации',
                path: '/specializations',
                icon: StarIcon,
                active: false,
                hasRole: 'ROLE_ADMIN'
            },
            {
                id: 'tariffs',
                text: 'Тарифы',
                path: '/tariffs',
                icon: StarIcon,
                active: false,
                hasRole: 'ROLE_ADMIN'
            },
            {
                id: 'usersAdmin',
                text: 'Пользователи',
                path: '/admin/users',
                icon: UserIcon,
                active: false,
                hasRole: 'ROLE_ADMIN'
            },
            {
                id: 'models',
                text: 'Модели',
                path: '/admin/models',
                icon: Stars,
                active: false,
                hasRole: 'ROLE_ADMIN'
            },
            {
                id: 'payment',
                text: 'Подписки',
                path: '/payment',
                icon: StarIcon,
                active: false,
                minRole: 'ROLE_OWNER',
                excludeRole: 'ROLE_ADMIN',
                bottom: true
            },
            // {
            //     id: 'profile',
            //     text: 'Профиль',
            //     path: '/profile',
            //     icon: UserIcon,
            //     active: false,
            // },
        ],
        isNavBarVisible: localStorage.getItem('isNavBarVisible') !== null
            ? localStorage.getItem('isNavBarVisible') === 'true'
            : window.innerWidth > 768,
        isHeaderVisible: localStorage.getItem('isHeaderVisible') !== 'false',
        isAiChatVisible: localStorage.getItem('isAiChatVisible') === 'true',
    }),

    getters: {
        visibleTabs: (state) => {
            const userStore = useUserStore();
            const userRole = getMaxRole(userStore.myUserInfo?.roles);

            var filteredTabs = state.tabs.filter(tab => {
                if (tab.minRole && !checkRole(userRole, tab.minRole)) return false;
                if (tab.maxRole && !checkRole(tab.maxRole, userRole)) return false;
                return true;
            });

            filteredTabs = filteredTabs.filter(tab => {
                if (tab.hasRole && !findRole(userStore.myUserInfo?.roles, tab.hasRole)) return false;
                if (tab.hasRoles && !tab.hasRoles.some(r => findRole(userStore.myUserInfo?.roles, r))) return false;
                if (tab.excludeRole && findRole(userStore.myUserInfo?.roles, tab.excludeRole)) return false;
                if (tab.excludeRoles && tab.excludeRoles.some(r => findRole(userStore.myUserInfo?.roles, r))) return false;
                if (tab.llmEnabled && !userStore.myUserInfo?.llmEnabled) return false;
                return true;
            });

            return filteredTabs
        }
    },

    actions: {
        setActiveTab(tabId) {
            this.tabs.forEach(item => {
                item.active = false;
            })
            const tab = this.tabs.find(item => item.id === tabId);
            if (tab) {
                tab.active = true;
            }
            this.activeTabId = tabId;
            localStorage.setItem("active_tab", tabId);
        },

        setNavBarVisible(isVisible) {
            this.isNavBarVisible = isVisible;
            localStorage.setItem('isNavBarVisible', isVisible);
        },

        setHeaderVisible(isVisible) {
            this.isHeaderVisible = isVisible;
            localStorage.setItem('isHeaderVisible', isVisible);
        },

        toggleNavBar() {
            this.isNavBarVisible = !this.isNavBarVisible;
            localStorage.setItem('isNavBarVisible', this.isNavBarVisible);
        },

        toggleAiChat() {
            this.isAiChatVisible = !this.isAiChatVisible;
            localStorage.setItem('isAiChatVisible', this.isAiChatVisible);
        }
    }
})
